<template lang="html">
  <div class="mini-invoice">
    <div class="invoice-row">
      <v-skeleton-loader
      boilerplate
      type="article"
      light
      width="50%"
      ></v-skeleton-loader>
      <v-skeleton-loader
      boilerplate
      type="image"
      light
      width="25%"
      ></v-skeleton-loader>
    </div>
    <div class="invoice-row">
      <h4>{{ invoice.number }}</h4>
    </div>
    <div class="invoice-row-right">
      <v-skeleton-loader
      boilerplate
      type="article"
      light
      width="25%"
      ></v-skeleton-loader>
    </div>
    <div class="invoice-row-right">
      <h4>{{ new Date(invoice.created).toDateString() }}</h4>
    </div>
    <div class="invoice-row">
      <v-skeleton-loader
      boilerplate
      type="table-heading, table-heading, table-heading"
      light
      width="90%"
      ></v-skeleton-loader>
    </div>
    <div class="invoice-row-right">
      <h4>{{ invoice.total_cost }} {{$t('Project.Settings.Pay.Currency')}}</h4>
    </div>
    <div class="invoice-row">
      <v-skeleton-loader
      boilerplate
      type="text"
      light
      width="50%"
      ></v-skeleton-loader>
    </div>
    <div class="invoice-row">
      <v-skeleton-loader
      boilerplate
      type="text"
      light
      width="25%"
      ></v-skeleton-loader>
    </div>
    <div class="invoice-row">
      <div class="invoice-status">
        {{$t('Project.Settings.Pay.InvoiceStatus')}}: {{ invoice.status }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['invoice']
}
</script>

<style lang="css" scoped>
.mini-invoice {
  zoom: 0.25;
  width: 210mm;
  height: 297mm;
  font-size: 14mm;
  background-color: white;
  color: black;
  padding: 10px 20px;
  cursor: pointer !important;
}

.v-skeleton-loader {
  cursor: pointer !important;
}

.invoice-row {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 6mm;
}

.invoice-row-right {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: 6mm;
}

.invoice-status {
  /* position: absolute; */
  bottom: 5px;
  right: 5px;
  /* transform: rotate(-15deg); */

}

</style>
